export const rules = {
	// Card titles
	"rules.card.rules.title": "Regeln",
	"rules.card.pointsAllocation.title": "Punkteverteilung",
	"rules.card.rulesContinued.title": "Regeln (Fortsetzung)",
	"rules.card.weeklyPrizes.title": "Wöchentliche Preisstruktur",

	// Main rules content
	"rules.intro":
		'Alle großgeschriebenen Begriffe, die in diesen Regeln (den <strong>"Regeln"</strong>) verwendet werden, tragen die ihnen in den Allgemeinen Geschäftsbedingungen (den <strong>"Allgemeinen Geschäftsbedingungen"</strong>) zugeschriebene Definition.',

	"rules.temporary_notice":
		"Bitte beachten Sie, dass Preisgewinner im Zeitraum vom 19. Dezember 2025 bis 2. Januar 2026 ihre Preise innerhalb von 7 (sieben) Tagen ab dem 6. Januar 2026 erhalten werden",

	"rules.rule1":
		"Teilnehmer können Punkte verdienen, indem sie das Ergebnis von jeweils fünf (5) Spielen jede Woche/Runde (je nach Fall) korrekt vorhersagen, die sich auf den Sportwettbewerb beziehen, auf den sich das Betway Scores BW ScorePredict-Spiel bezieht, z.B. <em>English Premier League</em>, etc. Der Betway Scores BW Score Predict-Wettbewerb beginnt am 11. März 2025 und endet am Ende der Fußballsaison 2025/2026.",

	"rules.rule2.main": "Teilnehmer können zusätzliche Bonuspunkte verdienen, indem sie in jedem der fünf (5) Spiele folgendes korrekt vorhersagen:",
	"rules.rule2.a": "Korrektes Endergebnis",
	"rules.rule2.b": "Korrekter Gewinner",
	"rules.rule2.c": "Korrekte Heimtore",
	"rules.rule2.d": "Korrekte Auswärtstore",
	"rules.rule2.e": "Korrekte Tordifferenz",

	"rules.rule3": "Jede Woche/Runde korreliert mit den Runden dieses Sportwettbewerbs.",

	"rules.rule4": "Punkte werden wie folgt für jede der folgenden korrekten Vorhersagen des Teilnehmers jede Woche/Runde vergeben:",

	// Points allocation
	"rules.points.correctScore": "Korrektes Endergebnis",
	"rules.points.correctScoreValue": "50",
	"rules.points.correctWinner": "Korrekter Gewinner",
	"rules.points.correctWinnerValue": "5",
	"rules.points.homeGoals": "Korrekte Heimtore",
	"rules.points.homeGoalsValue": "5",
	"rules.points.awayGoals": "Korrekte Auswärtstore",
	"rules.points.awayGoalsValue": "5",
	"rules.points.goalDifference": "Korrekte Tordifferenz",
	"rules.points.goalDifferenceValue": "5",

	// Continued rules
	"rules.rule5":
		"Teilnehmer können ihre Vorhersagen jederzeit ändern, bis zu 15 Minuten vor Anpfiff jedes der Spiele der entsprechenden Woche/Runde.",

	"rules.rule6":
		"Alle angemeldeten Betway Scores und/oder BW Scores-Benutzer sind berechtigt, Betway Scores BW ScorePredict zu spielen, jedoch sind nur Teilnehmer mit einem verifizierten Betway-Konto zum Zeitpunkt der Preisverleihung berechtigt, Preise zu gewinnen. Änderungen der Spielergebnisse gemäß Punkt 2. oben, die nach der Preisverleihung auftreten (z.B. Annullierung des Ergebnisses), werden nicht rückwirkend berücksichtigt.",

	"rules.rule7":
		"Der qualifizierte und berechtigte Teilnehmer, der die Saison auf dem ersten Platz beendet und ein Betway-Konto hat, wird der Hauptpreisgewinner der Saison sein und eine Reise für zwei (2) Personen gewinnen, um Arsenal in London spielen zu sehen, einschließlich Flüge (falls erforderlich), Unterkunft (falls erforderlich) und £500 Taschengeld.",

	"rules.rule8":
		"Wenn der Hauptpreisgewinner der Saison nicht reisen kann, weil er keinen gültigen Reisepass und/oder kein Visum und/oder andere Einschränkungen hat, erhält er einen Preis von €5.000 Barguthaben oder den ungefähren Gegenwert in lokaler Währung zum Wettbewerbsbeginn (£4.500, R100.000 oder GH₵ 60.000) auf sein Betway-Konto nach Abschluss des Wettbewerbs.",

	"rules.rule9":
		"Der Hauptpreisgewinner der Saison kann sich entscheiden, das Erlebnis nicht anzunehmen und stattdessen einen Preis von €5.000 Barguthaben oder den ungefähren Gegenwert in lokaler Währung zum Wettbewerbsbeginn (£4.500, R100.000 oder GH₵ 60.000) auf sein Betway-Konto zu akzeptieren.",

	"rules.rule10":
		'Wöchentliche Preise werden an die "Top 10" Leistungsträger jede Woche/Runde vergeben, die ein gültiges Betway-Wettkonto haben. Wenn ein Top-10-Leistungsträger kein Betway-Wettkonto hat, erhält er keinen wöchentlichen Preis.',

	"rules.rule11": "Die wöchentlichen Plätze 1 bis 10 gewinnen die folgenden Barguthaben-Beträge, abhängig von ihrer Region, auf ihr Betway-Konto.",

	"rules.rule12":
		"Die wöchentlichen Preise werden innerhalb von 7 (sieben) Tagen nach Abschluss der Ergebnisse dieser Woche vergeben und der Hauptpreis wird innerhalb von 7 (sieben) Tagen nach Abschluss des Betway Scores BW Score Predict-Wettbewerbs vergeben.",

	"rules.rule13":
		"Im Falle eines Unentschiedens für die wöchentlichen Preise wird das Barguthaben für diese Position (und die relevanten Positionen darunter, die vom Unentschieden betroffen sind) gleichmäßig zwischen den unentschiedenen Teilnehmern aufgeteilt.",

	"rules.rule14":
		"Im Falle eines Unentschiedens für den Hauptpreis wird ein Zufallsmechanismus verwendet, um nur einen der unentschiedenen Teilnehmer als Gewinner des Hauptpreises auszuwählen.",

	// Weekly prize table data
	"rules.weeklyPrizes.position1.eur": "€150",
	"rules.weeklyPrizes.position1.gbp": "£150",
	"rules.weeklyPrizes.position1.zar": "R3000",
	"rules.weeklyPrizes.position1.ghs": "GH₵2000",

	"rules.weeklyPrizes.position2.eur": "€100",
	"rules.weeklyPrizes.position2.gbp": "£100",
	"rules.weeklyPrizes.position2.zar": "R2000",
	"rules.weeklyPrizes.position2.ghs": "GH₵1250",

	"rules.weeklyPrizes.position3.eur": "€75",
	"rules.weeklyPrizes.position3.gbp": "£75",
	"rules.weeklyPrizes.position3.zar": "R1500",
	"rules.weeklyPrizes.position3.ghs": "GH₵1000",

	"rules.weeklyPrizes.position4.eur": "€50",
	"rules.weeklyPrizes.position4.gbp": "£50",
	"rules.weeklyPrizes.position4.zar": "R1000",
	"rules.weeklyPrizes.position4.ghs": "GH₵600",

	"rules.weeklyPrizes.position5.eur": "€40",
	"rules.weeklyPrizes.position5.gbp": "£40",
	"rules.weeklyPrizes.position5.zar": "R800",
	"rules.weeklyPrizes.position5.ghs": "GH₵500",

	"rules.weeklyPrizes.position6.eur": "€30",
	"rules.weeklyPrizes.position6.gbp": "£30",
	"rules.weeklyPrizes.position6.zar": "R600",
	"rules.weeklyPrizes.position6.ghs": "GH₵400",

	"rules.weeklyPrizes.position7.eur": "€20",
	"rules.weeklyPrizes.position7.gbp": "£20",
	"rules.weeklyPrizes.position7.zar": "R400",
	"rules.weeklyPrizes.position7.ghs": "GH₵250",

	"rules.weeklyPrizes.position8.eur": "€15",
	"rules.weeklyPrizes.position8.gbp": "£15",
	"rules.weeklyPrizes.position8.zar": "R300",
	"rules.weeklyPrizes.position8.ghs": "GH₵200",

	"rules.weeklyPrizes.position9.eur": "€10",
	"rules.weeklyPrizes.position9.gbp": "£10",
	"rules.weeklyPrizes.position9.zar": "R200",
	"rules.weeklyPrizes.position9.ghs": "GH₵100",

	"rules.weeklyPrizes.position10.eur": "€10",
	"rules.weeklyPrizes.position10.gbp": "£10",
	"rules.weeklyPrizes.position10.zar": "R200",
	"rules.weeklyPrizes.position10.ghs": "GH₵100",

	// Table headers
	"rules.weeklyPrizes.header.position": "# Pro Runde",
	"rules.weeklyPrizes.header.eur": "EUR",
	"rules.weeklyPrizes.header.gbp": "GBP",
	"rules.weeklyPrizes.header.zar": "ZAR",
	"rules.weeklyPrizes.header.ghs": "GHS",
};
